<div class="tenant-selection-container">
  <div class="content-wrapper">
    <!-- Header Section (clean, text-only) -->
    <div class="page-header">
      <div class="title-section">
        <h1 class="welcome-title">{{ dataService.getTexts().TenantSelectionWelcomeTitle }}</h1>
        <p class="welcome-subtitle">{{ dataService.getTexts().TenantSelectionWelcomeSubtitle }}</p>
      </div>
    </div>

    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-section">
        <div class="loading-content">
          <p-progressSpinner
            styleClass="w-4rem h-4rem"
            strokeWidth="3"
            animationDuration="1s"
            ariaLabel="Loading organizations"
          >
          </p-progressSpinner>
          <p class="loading-text">{{ dataService.getTexts().RequestWaitMessage }}</p>
        </div>
      </div>
    }

    <!-- Tenant Selection -->
    @if (!isLoading) {
      <div class="tenant-selection-section">
        <div class="tenants-grid">
          @for (tenant of connectedTenants; track tenant) {
            <div
              class="tenant-card"
              [class.selected]="selectedTenantId === tenant.tenantId"
              role="button"
              [attr.aria-label]="tenant.displayName"
              tabindex="0"
              (click)="selectTenant(tenant.tenantId)"
              (keydown.enter)="selectTenant(tenant.tenantId)"
              (keydown.space)="selectTenant(tenant.tenantId)"
            >
              <div class="tenant-card-content">
                <div class="tenant-icon">
                  <i class="pi pi-building"></i>
                </div>
                <div class="tenant-info">
                  <h3 class="tenant-name">{{ tenant.displayName }}</h3>
                  <p class="tenant-id">{{ tenant.tenantId }}</p>
                </div>
                <!-- Optional: Auswahl-Indikator für die ausgewählte Card -->
                @if (selectedTenantId === tenant.tenantId) {
                  <div class="selected-indicator">
                    <i class="pi pi-check-circle"></i>
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <!-- Empty State -->
        @if (connectedTenants.length === 0) {
          <div class="empty-state">
            <div class="empty-content">
              <i class="pi pi-inbox empty-icon"></i>
              <h3 class="empty-title">{{ dataService.getTexts().NoOrganizationsAvailable }}</h3>
              <p class="empty-description">{{ dataService.getTexts().NoOrganizationsFound }}</p>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
